/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ProjectPeopleList } from './types';

enum Api {
  projectPeopleList = '/front-end/api/v1/project/people/list', // 【项目人员】 列表
  auditQua = '/front-end/api/v1/project/people/batch/review', // 【项目人员】审核资质
  enablePeople = '/front-end/api/v1/project/people/enable', // 【项目人员】 停启用 (单独批量）
  deletePeople = '/front-end/api/v1/project/people/delete', // 【项目人员】 删除
  preProcurementTaskQuantity = '/front-end/api/v1/project/people/add/preProcurementTaskQuantity', // 【项目人员】 （单独预采购任务数量）
  allianceUserRnv = '/front-end/api/v1/project/people/allianceUserRnv', // 【项目人员】实名开户信息
  occupationAuthInfo = '/front-end/api/v1/project/people/occupationAuthInfo', // 【项目人员】获取用户职业认证背景信息
  projectQualificationsInfo = '/front-end/api/v1/project/people/projectQualificationsInfo', // 【项目人员】获取项目资质信息
  peopleCheck = '/front-end/api/v1/project/people/check', // 【项目人员】获取check可选值
  modifyProjectPeopleUserTag = '/front-end/api/v1/project/people/modifyProjectPeopleUserTag', // 修改人员标签

  modifyProjectPeopleUserName = '/front-end/api/v1/project/people/modifyProjectPeopleUserName', // 修改人员姓名 手机号

  downloadTemplate = '/front-end/api/v1/download/excel/template', // 下载导入模板
  downloadSurplus = '/front-end/api/v1/project/people/download/surplus', // 下载项目剩余量
  importProjectPeople = '/front-end/api/v1/project/people/import/project/people', // 导入人员（预采购任务量 批量添加）
  checkImportExcel = '/front-end/api/v1/project/people/check/import/excel', // 检查导入的Excel文件
  cancelImportExcel = '/front-end/api/v1/project/people/cancel/import', // 取消导入
  getOriginalExcel = '/front-end/api/v1/project/people/download/original/excel', // 下载原导入的excel 文件
  againSubmit = '/front-end/api/v1/project/people/import/project/people/again', // 重新提交
  cleanProjectWorkload = '/front-end/api/v1/project/people/cleanProjectWorkload', //清除预采购任务量

  peopleListExport = '/front-end/api/v1/project/people/list/export' // 【项目人员】 列表导出
}

export const projectPeopleList: ProjectPeopleList = params =>
  http.request({
    url: Api.projectPeopleList,
    method: 'POST',
    params
  });

export const modifyProjectPeopleUserTag = (params: {
  projectId: number;
  userId: number[];
  userTag?: string;
}) =>
  http.request({
    url: Api.modifyProjectPeopleUserTag,
    method: 'POST',
    params
  });
export const modifyProjectPeopleUserName = (params: {
  projectId: number;
  userId: number;
  userName: string;
  phone: number;
}) =>
  http.request({
    url: Api.modifyProjectPeopleUserName,
    method: 'POST',
    params
  });

export const peopleCheck = (
  params: any
): Promise<
  Result<{
    count: number; //可选数量
    userId: number[]; //可选用户ids
  }>
> =>
  http.request({
    url: Api.peopleCheck,
    method: 'POST',
    params
  });
export const auditQua = (params: {
  projectId: number;
  userId: number[];
  auditStatus: number;
  auditOpinion?: string;
  auditType: number;
}) =>
  http.request({
    url: Api.auditQua,
    method: 'POST',
    params
  });

export const enablePeople = (params: {
  projectId: number;
  userId: number[];
  enabled: number; //,0-是(启用）,1-否(停用）
}) =>
  http.request({
    url: Api.enablePeople,
    method: 'POST',
    params
  });

export const deletePeople = (params: { userId: number; projectId: number }) =>
  http.request({
    url: Api.deletePeople + `/${params.userId}/${params.projectId}`,
    method: 'GET'
  });

export const preProcurementTaskQuantity = (params: {
  projectId: number;
  name: string;
  phone: number;
  procurementTaskQuantity: number;
  importMethod: number;
  userTag: string;
  prePurchaseAt: string;
}) =>
  http.request({
    url: Api.preProcurementTaskQuantity,
    method: 'POST',
    params
  });

export const allianceUserRnv = (params: {
  userId: number;
}): Promise<
  Result<{
    phone: string; //手机号
    name: string; //终端服务人员姓名
    cardId: string; //身份证号
    cardIdFront: string; //身份证正面照片
    cardIdBack: string; //身份证背面照片
    bankCardNum: string; //银行卡号
    bankInfo: string; //银行名称
  }>
> =>
  http.request({
    url: Api.allianceUserRnv + `/${params.userId}`,
    method: 'GET'
  });

export const occupationAuthInfo = (params: {
  userId: number;
}): Promise<
  Result<{
    certificatesNo: string; //证书编号
    name: string; //医师姓名
    provinceName: string; //省份
    hospitalName: string; //医院名称
  }>
> =>
  http.request({
    url: Api.occupationAuthInfo + `/${params.userId}`,
    method: 'GET'
  });

export const projectQualificationsInfo = (params: {
  userId: number;
  projectId: number;
}): Promise<
  Result<{
    projectId: number;
    userId: number;
    name: string;
    phone: number;
    projectQualifications: string[];
    projectQualificationsDetail: any[];
  }>
> =>
  http.request({
    url:
      Api.projectQualificationsInfo + `/${params.projectId}/${params.userId}`,
    method: 'GET'
  });

export const downloadTemplate = (params: { excelGroupCode: string }) =>
  http.download({
    url: Api.downloadTemplate + '/' + params.excelGroupCode,
    method: 'GET'
  });

export const downloadSurplus = (params: { projectId: number }) =>
  http.download({
    url: Api.downloadSurplus + '/' + params.projectId,
    method: 'GET'
  });

// export const importProjectPeople = params =>
//   http.request({
//     url: Api.importProjectPeople,
//     method: 'POST',
//     params
//   });

export const importProjectPeople = params =>
  http.uploadFile(
    {
      url: Api.importProjectPeople,
      method: 'POST',
      params
    },
    {
      isParseToJson: true
    }
  );

export const checkImportExcel = params =>
  http.uploadFile(
    {
      url: Api.checkImportExcel,
      method: 'POST',
      params
    },
    {
      isParseToJson: true
    }
  );

export const cancelImportExcel = params =>
  http.request({
    url: Api.cancelImportExcel + '/' + params.excelCode,
    method: 'GET'
  });

export const getOriginalExcel = params =>
  http.download({
    url: Api.getOriginalExcel + '/' + params.excelCode,
    method: 'GET'
  });

export const peopleListExport = params =>
  http.download({
    url: Api.peopleListExport,
    method: 'POST',
    params
  });

export const againSubmit = async (params: { inVO: any; dataList: any[] }) =>
  http.request({
    url: Api.againSubmit,
    method: 'POST',
    params
  });

export const cleanProjectWorkload = params =>
  http.request({
    url: Api.cleanProjectWorkload + '/' + params.projectId,
    method: 'GET'
  });
